import React, { useState, useEffect, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimes, 
  faSearch, 
  faCalendarAlt, 
  faUserShield, 
  faChevronDown,
  faCheck,
  faSpinner,
  faArrowLeft
} from '@fortawesome/free-solid-svg-icons';
import { liteClient } from 'algoliasearch/lite';
import styles from './SearchBandsModal.module.css';
import defaultBandPic from '../../assets/Images/defaultUserProfilePicture.png';
import verifiedBadge from '../../assets/Images/profileverifiedtick.png';
import UserContext from '../../context/UserContext';

// Initialize Algolia client
const client = liteClient('6DJNAZSX4P', '342932cbe26f7751ec87fa2b1ff32e4c');

// Complete ROLE_OPTIONS from the provided data
const ALL_ROLE_OPTIONS = [
  // Artist subtypes
  { value: 'Bass Guitarist', label: 'Bass Guitarist', category: 'Artist' },
  { value: 'Cellist', label: 'Cellist', category: 'Artist' },
  { value: 'DJ', label: 'DJ', category: 'Artist' },
  { value: 'Dhol Player', label: 'Dhol Player', category: 'Artist' },
  { value: 'Dholak Player', label: 'Dholak Player', category: 'Artist' },
  { value: 'Drummer', label: 'Drummer', category: 'Artist' },
  { value: 'Flutist', label: 'Flutist', category: 'Artist' },
  { value: 'Ghatam Player', label: 'Ghatam Player', category: 'Artist' },
  { value: 'Guitarist', label: 'Guitarist', category: 'Artist' },
  { value: 'Harmonium Player', label: 'Harmonium Player', category: 'Artist' },
  { value: 'Keyboardist', label: 'Keyboardist', category: 'Artist' },
  { value: 'Mridangam Player', label: 'Mridangam Player', category: 'Artist' },
  { value: 'Music Producer', label: 'Music Producer', category: 'Artist' },
  { value: 'Percussionist', label: 'Percussionist', category: 'Artist' },
  { value: 'Rapper', label: 'Rapper', category: 'Artist' },
  { value: 'Santoor Player', label: 'Santoor Player', category: 'Artist' },
  { value: 'Sarod Player', label: 'Sarod Player', category: 'Artist' },
  { value: 'Saxophonist', label: 'Saxophonist', category: 'Artist' },
  { value: 'Shehnai Player', label: 'Shehnai Player', category: 'Artist' },
  { value: 'Sitar Player', label: 'Sitar Player', category: 'Artist' },
  { value: 'Tabla Player', label: 'Tabla Player', category: 'Artist' },
  { value: 'Trumpeter', label: 'Trumpeter', category: 'Artist' },
  { value: 'Veena Player', label: 'Veena Player', category: 'Artist' },
  { value: 'Violinist', label: 'Violinist', category: 'Artist' },
  { value: 'Vocalist', label: 'Vocalist', category: 'Artist' },
  
  // Crew subtypes
  { value: 'Backline Technician', label: 'Backline Technician', category: 'Crew' },
  { value: 'Dresser', label: 'Dresser', category: 'Crew' },
  { value: 'Drum Tech', label: 'Drum Tech', category: 'Crew' },
  { value: 'Guitar Tech', label: 'Guitar Tech', category: 'Crew' },
  { value: 'Keyboard Tech', label: 'Keyboard Tech', category: 'Crew' },
  { value: 'Light Engineer', label: 'Light Engineer', category: 'Crew' },
  { value: 'Lighting Technician', label: 'Lighting Technician', category: 'Crew' },
  { value: 'Makeup Artist', label: 'Makeup Artist', category: 'Crew' },
  { value: 'Merchandiser', label: 'Merchandiser', category: 'Crew' },
  { value: 'Monitor Engineer', label: 'Monitor Engineer', category: 'Crew' },
  { value: 'Photographer', label: 'Photographer', category: 'Crew' },
  { value: 'Rigger', label: 'Rigger', category: 'Crew' },
  { value: 'Road Manager', label: 'Road Manager', category: 'Crew' },
  { value: 'Security Personnel', label: 'Security Personnel', category: 'Crew' },
  { value: 'Sound Engineer', label: 'Sound Engineer', category: 'Crew' },
  { value: 'Stage Manager', label: 'Stage Manager', category: 'Crew' },
  { value: 'Stage Tech', label: 'Stage Tech', category: 'Crew' },
  { value: 'Tour Bus Driver', label: 'Tour Bus Driver', category: 'Crew' },
  { value: 'Videographer', label: 'Videographer', category: 'Crew' },
  
  // Manager subtypes
  { value: 'Tour Manager', label: 'Tour Manager', category: 'Manager' },
  { value: 'Artist Manager', label: 'Artist Manager', category: 'Manager' },
  
  // Vendor subtypes
  { value: 'Backline Provider', label: 'Backline Provider', category: 'Vendor' },
  { value: 'Light Vendor', label: 'Light Vendor', category: 'Vendor' },
  { value: 'Sound Vendor', label: 'Sound Vendor', category: 'Vendor' },
  { value: 'Stage and Production Vendor', label: 'Stage and Production Vendor', category: 'Vendor' },
  
  // Staff subtypes
  { value: 'Backline Equipment Coordinator', label: 'Backline Equipment Coordinator', category: 'Staff' },
  { value: 'Instrument Maintenance Technician', label: 'Instrument Maintenance Technician', category: 'Staff' },
  { value: 'Backline Logistics Coordinator', label: 'Backline Logistics Coordinator', category: 'Staff' },
  { value: 'Equipment Setup Technician', label: 'Equipment Setup Technician', category: 'Staff' },
  { value: 'Lighting Setup Technician', label: 'Lighting Setup Technician', category: 'Staff' },
  { value: 'Lighting Board Operator', label: 'Lighting Board Operator', category: 'Staff' },
  { value: 'Lighting Rig Technician', label: 'Lighting Rig Technician', category: 'Staff' },
  { value: 'DMX Systems Specialist', label: 'DMX Systems Specialist', category: 'Staff' },
  { value: 'Moving Light Technician', label: 'Moving Light Technician', category: 'Staff' },
  { value: 'PA System Technician', label: 'PA System Technician', category: 'Staff' },
  { value: 'Audio Setup Specialist', label: 'Audio Setup Specialist', category: 'Staff' },
  { value: 'Speaker Systems Technician', label: 'Speaker Systems Technician', category: 'Staff' },
  { value: 'Audio Equipment Coordinator', label: 'Audio Equipment Coordinator', category: 'Staff' },
  { value: 'FOH Systems Technician', label: 'FOH Systems Technician', category: 'Staff' },
  { value: 'Stage Construction Technician', label: 'Stage Construction Technician', category: 'Staff' },
  { value: 'Truss System Specialist', label: 'Truss System Specialist', category: 'Staff' },
  { value: 'Stage Equipment Coordinator', label: 'Stage Equipment Coordinator', category: 'Staff' },
  { value: 'Production Setup Coordinator', label: 'Production Setup Coordinator', category: 'Staff' },
  { value: 'Staging Logistics Specialist', label: 'Staging Logistics Specialist', category: 'Staff' },
  
];

const SearchBandsModal = ({ isOpen, onClose, onSelect, isPastSearch = false, extraContent }) => {
  const { userData } = useContext(UserContext); // Get current user data from context
  const [activeTab, setActiveTab] = useState('Artists');
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  
  // New state for two-step selection process
  const [selectedEntity, setSelectedEntity] = useState(null);
  const [roleSearch, setRoleSearch] = useState('');
  const [showRoleDropdown, setShowRoleDropdown] = useState(false);
  const [selectedRole, setSelectedRole] = useState('');
  
  // For dates - imported from parent
  const [sinceMonth, setSinceMonth] = useState('');
  const [sinceYear, setSinceYear] = useState('');
  const [startMonth, setStartMonth] = useState('');
  const [startYear, setStartYear] = useState('');
  const [endMonth, setEndMonth] = useState('');
  const [endYear, setEndYear] = useState('');

  // Get role options based on current user's userType
  const [filteredRoleOptions, setFilteredRoleOptions] = useState([]);

  // Filter role options based on current user's userType
  useEffect(() => {
    if (userData && userData.userType) {
      if (isPastSearch) {
        // For past associations, show ALL role options
        setFilteredRoleOptions(ALL_ROLE_OPTIONS);
      } else {
        // For current associations, only show roles matching the user's type
        const userTypeRoles = ALL_ROLE_OPTIONS.filter(role => 
          role.category === userData.userType
        );
        setFilteredRoleOptions(userTypeRoles);
      }
    } else {
      // Fallback to all options if userData is not available
      setFilteredRoleOptions(ALL_ROLE_OPTIONS);
    }
  }, [userData, isPastSearch]);

  const handleSearch = async () => {
    if (!searchTerm.trim()) return;

    setIsLoading(true);
    try {
      let searchIndex;
      let filters = '';

      if (activeTab === 'Artists') {
        searchIndex = 'users_index';
        filters = 'userType:Artist';
      } else {
        searchIndex = 'bands_index';
      }

      const { results } = await client.search([{
        indexName: searchIndex,
        query: searchTerm,
        filters,
        hitsPerPage: 10
      }]);

      const mappedResults = results[0].hits.map(hit => {
        if (activeTab === 'Artists') {
          return {
            id: hit.objectID,
            name: hit.fullName,
            username: hit.userName,
            subType: hit.userSubType,
            photoUrl: hit.profilePictureUrl,
            verified: hit.idVerificationStatus === 'Verified',
            location: [hit.city, hit.state, hit.country].filter(Boolean).join(', '),
            type: 'artist' // Add this explicit type
          };
        } else {
          return {
            id: hit.objectID,
            name: hit.bandFullName,
            username: hit.bandUserName,
            genre: hit.bandGenres?.join(', '),
            photoUrl: hit.bandProfilePictureUrl,
            verified: hit.verified || false,
            location: [hit.city, hit.state, hit.country].filter(Boolean).join(', '),
            type: 'band' // Add this explicit type
          };
        }
      });

      setSearchResults(mappedResults);
      setHasSearched(true);
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      setIsLoading(false);
    }
  };
  
  // Function to handle initial selection
  const handleInitialSelection = (entity) => {
    setSelectedEntity(entity);
    
    // Reset the role and date fields
    setSelectedRole('');
    setSinceMonth('');
    setSinceYear('');
    setStartMonth('');
    setStartYear('');
    setEndMonth('');
    setEndYear('');
  };
  
  // Function to handle final selection with role and dates
  const handleFinalSelection = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    if (!selectedEntity) return;
    
    // Validate that required fields are filled
    if (!selectedRole) {
      alert('Please select a role');
      return;
    }
    
    if (isPastSearch) {
      // Validate past association fields
      if (!startMonth || !startYear || !endMonth || !endYear) {
        alert('Please fill in all date fields');
        return;
      }
      
      // Validate date logic
      const startDate = new Date(parseInt(startYear), parseInt(startMonth) - 1);
      const endDate = new Date(parseInt(endYear), parseInt(endMonth) - 1);
      
      if (startDate > endDate) {
        alert('Start date must be before end date');
        return;
      }
    } else {
      // Validate current association fields
      if (!sinceMonth || !sinceYear) {
        alert('Please fill in the since date');
        return;
      }
    }
    
    // Create the enriched entity with role and date info
    const enrichedEntity = {
      ...selectedEntity,
      role: selectedRole,
      // Add a unique ID for each association that combines entity ID, role, and dates
      associationId: `${selectedEntity.id}-${selectedRole}-${Date.now()}`
    };
    
    if (isPastSearch) {
      enrichedEntity.duration = {
        startMonth,
        startYear,
        endMonth,
        endYear
      };
    } else {
      enrichedEntity.since = {
        month: sinceMonth,
        year: sinceYear
      };
    }
    
    // Call the parent's onSelect function
    onSelect(enrichedEntity);
    
    // Reset the state
    setSelectedEntity(null);
  };
  
  // Function to go back to search results
  const handleBackToSearch = () => {
    setSelectedEntity(null);
  };

  if (!isOpen) return null;

  // Filter roles based on search and user type
  const roleOptionsToDisplay = filteredRoleOptions.filter(role => 
    role.label.toLowerCase().includes(roleSearch.toLowerCase())
  );
  
  // Generate month options for dropdowns
  const generateMonthOptions = () => {
    return [
      { value: '1', label: 'January' },
      { value: '2', label: 'February' },
      { value: '3', label: 'March' },
      { value: '4', label: 'April' },
      { value: '5', label: 'May' },
      { value: '6', label: 'June' },
      { value: '7', label: 'July' },
      { value: '8', label: 'August' },
      { value: '9', label: 'September' },
      { value: '10', label: 'October' },
      { value: '11', label: 'November' },
      { value: '12', label: 'December' }
    ];
  };

  // Generate year options for dropdowns
  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear; i >= currentYear - 50; i--) {
      years.push({ value: i.toString(), label: i.toString() });
    }
    return years;
  };

  return (
    <div 
      className={styles.modalOverlay} 
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2>
            {selectedEntity 
              ? `Add ${selectedEntity.name} as ${isPastSearch ? 'Past ' : ''}Associated Act` 
              : `Search ${activeTab}`
            }
          </h2>
          <button className={styles.closeButton} onClick={onClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {!selectedEntity ? (
          // Search interface
          <>
            <div className={styles.tabs}>
              <button 
                className={`${styles.tab} ${activeTab === 'Artists' ? styles.active : ''}`}
                onClick={() => setActiveTab('Artists')}
              >
                Artists
              </button>
              <button 
                className={`${styles.tab} ${activeTab === 'Bands' ? styles.active : ''}`}
                onClick={() => setActiveTab('Bands')}
              >
                Bands
              </button>
            </div>

            <div className={styles.searchBar}>
              <input
                type="text"
                placeholder={`Search ${activeTab.toLowerCase()}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
              />
              <button 
                className={styles.searchButton}
                onClick={handleSearch}
                disabled={!searchTerm.trim() || isLoading}
              >
                {isLoading ? (
                  <FontAwesomeIcon icon={faSpinner} spin />
                ) : (
                  <FontAwesomeIcon icon={faSearch} />
                )}
                Search
              </button>
            </div>

            <div className={styles.searchResults}>
              {isLoading ? (
                <div className={styles.loading}>
                  <div className={styles.spinner}></div>
                  <p>Searching...</p>
                </div>
              ) : hasSearched ? (
                searchResults.length > 0 ? (
                  <div className={styles.resultsList}>
                    {searchResults.map(result => (
                      <div 
                        key={result.id}
                        className={styles.resultCard}
                        onClick={() => handleInitialSelection(result)}
                      >
                        <img 
                          src={result.photoUrl || defaultBandPic}
                          alt={result.name}
                          className={styles.resultPhoto}
                        />
                        <div className={styles.resultInfo}>
                          <div className={styles.nameContainer}>
                            <h3>{result.name}</h3>
                            {result.verified && (
                              <img 
                                src={verifiedBadge} 
                                alt="Verified" 
                                className={styles.verifiedBadge} 
                              />
                            )}
                          </div>
                          <p className={styles.username}>@{result.username}</p>
                          {activeTab === 'Artists' ? (
                            <p className={styles.subtype}>{result.subType}</p>
                          ) : (
                            <p className={styles.genre}>{result.genre}</p>
                          )}
                          <p className={styles.location}>{result.location}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={styles.noResults}>
                    No {activeTab.toLowerCase()} found for "{searchTerm}"
                  </div>
                )
              ) : (
                <div className={styles.searchPrompt}>
                  Search for {activeTab.toLowerCase()} by name or username
                </div>
              )}
            </div>
          </>
        ) : (
          // Details and role/date selection for the selected entity
          <form onSubmit={handleFinalSelection} className={styles.detailsForm}>
            <div className={styles.selectedEntityContainer}>
              <div className={styles.selectedEntityHeader}>Selected {selectedEntity.type === 'band' ? 'Band' : 'Artist'}:</div>
              <div className={styles.selectedEntityDetails}>
                <img 
                  src={selectedEntity.photoUrl || defaultBandPic}
                  alt={selectedEntity.name}
                  className={styles.resultPhoto}
                />
                <div className={styles.resultInfo}>
                  <div className={styles.nameContainer}>
                    <h3>{selectedEntity.name}</h3>
                    {selectedEntity.verified && (
                      <img 
                        src={verifiedBadge} 
                        alt="Verified" 
                        className={styles.verifiedBadge} 
                      />
                    )}
                  </div>
                  <p className={styles.username}>@{selectedEntity.username}</p>
                  {selectedEntity.type === 'artist' ? (
                    <p className={styles.subtype}>{selectedEntity.subType}</p>
                  ) : (
                    <p className={styles.genre}>{selectedEntity.genre}</p>
                  )}
                  <p className={styles.location}>{selectedEntity.location}</p>
                </div>
              </div>
            </div>
            
            {/* Role Selection - Showing only options matching the current user's userType */}
            <div className={styles.roleSelector}>
              <label className={styles.fieldLabel}>Role:</label>
              <div className={styles.roleDropdownContainer}>
                <div 
                  className={styles.roleDropdownTrigger}
                  onClick={() => setShowRoleDropdown(!showRoleDropdown)}
                >
                  {selectedRole || 'Select Role'}
                  <FontAwesomeIcon icon={faChevronDown} />
                </div>
                
                {showRoleDropdown && (
  <div className={styles.roleDropdown}>
    {isPastSearch && (
      <div className={styles.roleDropdownInfo}>
        All role types are available for past associations
      </div>
    )}
                    <div className={styles.roleSearchContainer}>
                      <input
                        type="text"
                        placeholder="Search roles..."
                        value={roleSearch}
                        onChange={(e) => setRoleSearch(e.target.value)}
                        className={styles.roleSearchInput}
                      />
                    </div>
                    
                    {roleOptionsToDisplay.length > 0 ? (
                      <div className={styles.roleOptionsList}>
                        {roleOptionsToDisplay.map((role) => (
                          <div 
                            key={role.value}
                            className={`${styles.roleOption} ${selectedRole === role.value ? styles.selectedRole : ''}`}
                            onClick={() => {
                              setSelectedRole(role.value);
                              setShowRoleDropdown(false);
                            }}
                          >
                            {role.label}
                            <span className={styles.roleCategory}>{role.category}</span>
                            {selectedRole === role.value && (
                              <FontAwesomeIcon icon={faCheck} className={styles.checkIcon} />
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className={styles.noRoleOptions}>
  {roleSearch.trim() ? 
    `No ${isPastSearch ? '' : userData?.userType || ''} roles found for "${roleSearch}"` : 
    `No ${isPastSearch ? '' : userData?.userType || ''} roles available`}
</div>
                    )}
                  </div>
                )}
              </div>
            </div>
            
            {/* Date Selection - only render what's appropriate for the current state */}
            <div className={styles.dateSelection}>
              <h3>{isPastSearch ? 'Duration' : 'Since'}</h3>
              
              {isPastSearch ? (
                // Past Association - Start and End Dates
                <div className={styles.dateFields}>
                  <div className={styles.dateFieldGroup}>
                    <label className={styles.fieldLabel}>Start Date:</label>
                    <div className={styles.dateInputGroup}>
                      <select 
                        className={styles.dateSelect}
                        value={startMonth}
                        onChange={(e) => setStartMonth(e.target.value)}
                        required
                      >
                        <option value="">Month</option>
                        {generateMonthOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      
                      <select 
                        className={styles.dateSelect}
                        value={startYear}
                        onChange={(e) => setStartYear(e.target.value)}
                        required
                      >
                        <option value="">Year</option>
                        {generateYearOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  
                  <div className={styles.dateFieldGroup}>
                    <label className={styles.fieldLabel}>End Date:</label>
                    <div className={styles.dateInputGroup}>
                      <select 
                        className={styles.dateSelect}
                        value={endMonth}
                        onChange={(e) => setEndMonth(e.target.value)}
                        required
                      >
                        <option value="">Month</option>
                        {generateMonthOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      
                      <select 
                        className={styles.dateSelect}
                        value={endYear}
                        onChange={(e) => setEndYear(e.target.value)}
                        required
                      >
                        <option value="">Year</option>
                        {generateYearOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              ) : (
                // Current Association - Since Date
                <div className={styles.dateFields}>
                  <div className={styles.dateFieldGroup}>
                    <label className={styles.fieldLabel}>Since:</label>
                    <div className={styles.dateInputGroup}>
                      <select 
                        className={styles.dateSelect}
                        value={sinceMonth}
                        onChange={(e) => setSinceMonth(e.target.value)}
                        required
                      >
                        <option value="">Month</option>
                        {generateMonthOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      
                      <select 
                        className={styles.dateSelect}
                        value={sinceYear}
                        onChange={(e) => setSinceYear(e.target.value)}
                        required
                      >
                        <option value="">Year</option>
                        {generateYearOptions().map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
            
            <div className={styles.formActions}>
              <button 
                type="button" 
                className={styles.backButton}
                onClick={handleBackToSearch}
              >
                <FontAwesomeIcon icon={faArrowLeft} /> Back to Search
              </button>
              <button 
                type="submit" 
                className={styles.addButton}
              >
                Add {isPastSearch ? 'Past ' : ''}Associated Act
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default SearchBandsModal;